<template>
    <GChart
      type="LineChart"
      :data="chartData"
      :options="options"
      style="width: 100%"
    />
  </template>
  
<script>
import { GChart } from 'vue-google-charts'
export default {
    props: {
        trends: Array
    },

    components: {
        GChart
    },

    data() {
        return {
            options: {
                height: 300,
                curveType: 'function',
                legend: { position: 'bottom' }
            }
        }
    },

    computed: {
        chartData() {
            return [
                ['Month', 'Payroll'],
                ...(this.trends || []).map(item => [
                item.month,
                Number(item.total)
                ])
            ]
        }
    }
}
</script>